'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uploads = require('helpers/uploads');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UploaderFilesize = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(UploaderFilesize, _Component);

  function UploaderFilesize(args) {
    (0, _classCallCheck3.default)(this, UploaderFilesize);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UploaderFilesize.__proto__ || (0, _getPrototypeOf2.default)(UploaderFilesize)).call(this, args));

    _this.state = {
      size: (0, _uploads.getSize)(args.uploader, args.id)
    };

    _this.initUploaderEvents();
    return _this;
  }

  (0, _createClass3.default)(UploaderFilesize, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this._onUploadHandler) {
        this.props.uploader.on('upload', this._onUploadHandler);
      }
      this.props.uploader.on('submit', this._onSubmitHandler);
      this.props.uploader.on('statusChange', this._onStatusChangeHandler);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.size !== this.state.size;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._unmounted = true;
      if (this._onUploadHandler) {
        this.props.uploader.off('upload', this._onUploadHandler);
      }
      this.props.uploader.off('submit', this._onSubmitHandler);
      this.props.uploader.off('statusChange', this._onStatusChangeHandler);
    }
  }, {
    key: 'updateSize',
    value: function updateSize(id) {
      if (this._unmounted) {
        return false;
      }
      this.setState({
        size: (0, _uploads.getSize)(this.props.uploader, id)
      });
    }
  }, {
    key: 'initUploaderEvents',
    value: function initUploaderEvents() {
      var _this2 = this;

      // Don't bother to check size at upload time if scaling feature is not enabled.
      var scalingOption = this.props.uploader.options.scaling;
      if (scalingOption && scalingOption.sizes.length) {
        // If this is a scaled image, the size won't be known until upload time.
        this._onUploadHandler = function (id) {
          if (id === _this2.props.id) {
            _this2.updateSize(id);
          }
        };
      }

      this._onSubmitHandler = function () {
        if (_this2._isTotalProgress) {
          _this2.updateSize();
        }
      };

      this._onStatusChangeHandler = function () {
        if (_this2._isTotalProgress) {
          _this2.updateSize();
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          units = _props.units;
      var size = this.state.size;


      return _react2.default.createElement(_components.FileSize, { size: size, units: units, className: className });
    }
  }, {
    key: '_isTotalProgress',
    get: function get() {
      return typeof this.props.id === 'undefined';
    }
  }]);
  return UploaderFilesize;
}(_react.Component), _class.propTypes = {
  className: _propTypes2.default.string,
  id: _propTypes2.default.number,
  units: _propTypes2.default.object,
  uploader: _propTypes2.default.object.isRequired
}, _temp);
exports.default = UploaderFilesize;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FineUploader/UploaderFilesize.js
// module id = 2005
// module chunks = 1